import {Component, Input, OnInit} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Phone} from '../../../models/phone';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MyNumberOnlyDirective } from '../../directive/my-number-only.directive';
import { FormErrorMessageComponent } from '../form/form-error-message/form-error-message.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'tw-phone-form',
    templateUrl: './phone-form.component.html',
    styleUrls: ['./phone-form.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MyNumberOnlyDirective, MatError, FormErrorMessageComponent, TranslatePipe]
})
export class PhoneFormComponent implements OnInit {

    @Input() formGroupPhone:any | UntypedFormGroup;
    @Input()  phone: Phone;

    constructor(private fb: UntypedFormBuilder) {

    }

    ngOnInit() {
        this.formGroupPhone.addControl('number', this.fb.control((this.phone && this.phone.number) ? this.phone.number : '', Validators.required));

    }

}
